// Generated by purs version 0.14.3
"use strict";
var Control_Applicative = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/prelude/v5.0.1/src/Control/Applicative.purs");
var Control_Bind = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/prelude/v5.0.1/src/Control/Bind.purs");
var Control_Category = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/prelude/v5.0.1/src/Control/Category.purs");
var Control_Monad_Except = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/transformers/v5.2.0/src/Control/Monad/Except.purs");
var Control_Monad_Except_Trans = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/transformers/v5.2.0/src/Control/Monad/Except/Trans.purs");
var Control_Monad_Writer_Class = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/transformers/v5.2.0/src/Control/Monad/Writer/Class.purs");
var Control_Monad_Writer_Trans = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/transformers/v5.2.0/src/Control/Monad/Writer/Trans.purs");
var Control_Semigroupoid = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/prelude/v5.0.1/src/Control/Semigroupoid.purs");
var Data_Argonaut_Core = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/argonaut-core/v6.0.0/src/Data/Argonaut/Core.purs");
var Data_Argonaut_Decode_Class = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/argonaut-codecs/v8.1.0/src/Data/Argonaut/Decode/Class.purs");
var Data_Argonaut_Encode_Class = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/argonaut-codecs/v8.1.0/src/Data/Argonaut/Encode/Class.purs");
var Data_Codec = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/codec/v4.0.1/src/Data/Codec.purs");
var Data_Codec_Argonaut = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/codec-argonaut/v8.0.0/src/Data/Codec/Argonaut.purs");
var Data_Codec_Argonaut_Compat = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/codec-argonaut/v8.0.0/src/Data/Codec/Argonaut/Compat.purs");
var Data_Either = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/either/v5.0.0/src/Data/Either.purs");
var Data_Eq = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/prelude/v5.0.1/src/Data/Eq.purs");
var Data_Functor = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/prelude/v5.0.1/src/Data/Functor.purs");
var Data_Identity = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/identity/v5.0.0/src/Data/Identity.purs");
var Data_List_Types = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/lists/v6.0.1/src/Data/List/Types.purs");
var Data_Maybe = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/maybe/v5.0.0/src/Data/Maybe.purs");
var Data_Ord = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/prelude/v5.0.1/src/Data/Ord.purs");
var Data_Ordering = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/prelude/v5.0.1/src/Data/Ordering.purs");
var Data_Show = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/prelude/v5.0.1/src/Data/Show.purs");
var Data_String_Common = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/strings/v5.0.0/src/Data/String/Common.purs");
var Data_Symbol = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/prelude/v5.0.1/src/Data/Symbol.purs");
var Data_Tuple = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/tuples/v6.0.1/src/Data/Tuple.purs");
var Data_Unit = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/prelude/v5.0.1/src/Data/Unit.purs");
var Foreign = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/foreign/v6.0.1/src/Foreign.purs");
var Foreign_Index = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/foreign/v6.0.1/src/Foreign/Index.purs");
var Foreign_Object = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/foreign-object/v3.0.0/src/Foreign/Object.purs");
var Record_1 = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/record/v3.0.0/src/Record.purs");
var Record_Builder = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/record/v3.0.0/src/Record/Builder.purs");
var Simple_JSON = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/simple-json/v8.0.0/src/Simple/JSON.purs");
var Type_Data_RowList = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/prelude/v5.0.1/src/Type/Data/RowList.purs");
var SetRequired = function (setRequired) {
    this.setRequired = setRequired;
};
var RenameRequired = function (renameRequired) {
    this.renameRequired = renameRequired;
};
var $$Proxy = (function () {
    function $$Proxy() {

    };
    $$Proxy.value = new $$Proxy();
    return $$Proxy;
})();
var Partition = {};
var Option = function (x) {
    return x;
};
var ReadForeignOption = function (readImplOption) {
    this.readImplOption = readImplOption;
};
var Record = function (x) {
    return x;
};
var Rename = function (rename$prime) {
    this["rename'"] = rename$prime;
};
var $$Set = function (set$prime$prime) {
    this["set''"] = set$prime$prime;
};
var ToRecord = function (toRecord$prime) {
    this["toRecord'"] = toRecord$prime;
};
var RenameOptional = function (renameOptional) {
    this.renameOptional = renameOptional;
};
var SetOption = function (setOption) {
    this.setOption = setOption;
};
var ShowOption = function (showOption) {
    this.showOption = showOption;
};
var ToRecordOption = function (toRecordOption) {
    this.toRecordOption = toRecordOption;
};
var WriteForeignOption = function (writeForeignOption) {
    this.writeForeignOption = writeForeignOption;
};
var ModifyOption = function (modifyOption) {
    this.modifyOption = modifyOption;
};
var Modify = function (modify$prime$prime) {
    this["modify''"] = modify$prime$prime;
};
var JsonCodecRequired = function (jsonCodecRequired) {
    this.jsonCodecRequired = jsonCodecRequired;
};
var JsonCodecOption = function (jsonCodecOption) {
    this.jsonCodecOption = jsonCodecOption;
};
var JsonCodec = function (jsonCodec$prime) {
    this["jsonCodec'"] = jsonCodec$prime;
};
var InsertOption = function (insertOption) {
    this.insertOption = insertOption;
};
var Insert = function (insert$prime$prime) {
    this["insert''"] = insert$prime$prime;
};
var GetOption = function (getOption) {
    this.getOption = getOption;
};
var GetAllOption = function (getAllOption) {
    this.getAllOption = getAllOption;
};
var GetAll = function (getAll$prime) {
    this["getAll'"] = getAll$prime;
};
var Get = function (get$prime$prime) {
    this["get''"] = get$prime$prime;
};
var FromRecordRequired = function (fromRecordRequired) {
    this.fromRecordRequired = fromRecordRequired;
};
var FromRecordOption = function (fromRecordOption) {
    this.fromRecordOption = fromRecordOption;
};
var FromRecord = function (fromRecord$prime) {
    this["fromRecord'"] = fromRecord$prime;
};
var EqOption = function (eqOption) {
    this.eqOption = eqOption;
};
var OrdOption = function (EqOption0, compareOption) {
    this.EqOption0 = EqOption0;
    this.compareOption = compareOption;
};
var EncodeJsonOption = function (encodeJsonOption) {
    this.encodeJsonOption = encodeJsonOption;
};
var DeleteOption = function (deleteOption) {
    this.deleteOption = deleteOption;
};
var Delete = function (delete$prime$prime) {
    this["delete''"] = delete$prime$prime;
};
var DecodeJsonOption = function (decodeJsonOption) {
    this.decodeJsonOption = decodeJsonOption;
};
var AlterOption = function (alterOption) {
    this.alterOption = alterOption;
};
var Alter = function (alter$prime$prime) {
    this["alter''"] = alter$prime$prime;
};
var writeForeignOptionNil = new WriteForeignOption(function (v) {
    return function (v1) {
        return Foreign.unsafeToForeign({});
    };
});
var writeForeignOption = function (dict) {
    return dict.writeForeignOption;
};
var writeForeignOptionOption = function (dictRowToList) {
    return function (dictWriteForeignOption) {
        return new Simple_JSON.WriteForeign(writeForeignOption(dictWriteForeignOption)($$Proxy.value));
    };
};
var toRecordOptionNil = new ToRecordOption(function (v) {
    return function (v1) {
        return Control_Category.identity(Record_Builder.categoryBuilder);
    };
});
var toRecordOption = function (dict) {
    return dict.toRecordOption;
};
var toRecord$prime = function (dict) {
    return dict["toRecord'"];
};
var staticCheck = function (v) {
    return Data_Unit.unit;
};
var showOptionNil = new ShowOption(function (v) {
    return function (v1) {
        return Data_List_Types.Nil.value;
    };
});
var showOption = function (dict) {
    return dict.showOption;
};
var showOptionOption = function (dictRowToList) {
    return function (dictShowOption) {
        return new Data_Show.Show(function (option) {
            var go$prime = function ($copy_acc) {
                return function ($copy_x$prime) {
                    var $tco_var_acc = $copy_acc;
                    var $tco_done = false;
                    var $tco_result;
                    function $tco_loop(acc, x$prime) {
                        if (x$prime instanceof Data_List_Types.Cons) {
                            $tco_var_acc = acc + (", " + x$prime.value0);
                            $copy_x$prime = x$prime.value1;
                            return;
                        };
                        if (x$prime instanceof Data_List_Types.Nil) {
                            $tco_done = true;
                            return acc;
                        };
                        throw new Error("Failed pattern match at Option (line 253, column 18 - line 255, column 27): " + [ x$prime.constructor.name ]);
                    };
                    while (!$tco_done) {
                        $tco_result = $tco_loop($tco_var_acc, $copy_x$prime);
                    };
                    return $tco_result;
                };
            };
            var go = function (x$prime) {
                if (x$prime instanceof Data_List_Types.Cons && x$prime.value1 instanceof Data_List_Types.Nil) {
                    return " " + (x$prime.value0 + " ");
                };
                if (x$prime instanceof Data_List_Types.Cons) {
                    return " " + (go$prime(x$prime.value0)(x$prime.value1) + " ");
                };
                if (x$prime instanceof Data_List_Types.Nil) {
                    return "";
                };
                throw new Error("Failed pattern match at Option (line 247, column 13 - line 250, column 26): " + [ x$prime.constructor.name ]);
            };
            var fields = showOption(dictShowOption)($$Proxy.value)(option);
            return "(Option.fromRecord {" + (go(fields) + "})");
        });
    };
};
var setRequiredNil = new SetRequired(function (v) {
    return function (v1) {
        return function (record) {
            return record;
        };
    };
});
var setRequired = function (dict) {
    return dict.setRequired;
};
var setRequiredCons = function (dictIsSymbol) {
    return function (dictCons) {
        return function (dictCons1) {
            return function (dictCons2) {
                return function (dictLacks) {
                    return function (dictLacks1) {
                        return function (dictSetRequired) {
                            return new SetRequired(function (v) {
                                return function (record) {
                                    return function (oldRequired) {
                                        var oldRequired$prime = Record_1["delete"](dictIsSymbol)()()(Data_Symbol.SProxy.value)(oldRequired);
                                        var newRequired = setRequired(dictSetRequired)($$Proxy.value)(record)(oldRequired$prime);
                                        var value = Record_1.get(dictIsSymbol)()(Data_Symbol.SProxy.value)(record);
                                        return Record_1.insert(dictIsSymbol)()()(Data_Symbol.SProxy.value)(value)(newRequired);
                                    };
                                };
                            });
                        };
                    };
                };
            };
        };
    };
};
var setOptionNil = new SetOption(function (v) {
    return function (v1) {
        return function (option) {
            return option;
        };
    };
});
var setOption = function (dict) {
    return dict.setOption;
};
var set$prime$prime = function (dict) {
    return dict["set''"];
};
var required = function (record$prime) {
    return record$prime.required;
};
var renameRequiredNil = new RenameRequired(function (v) {
    return function (v1) {
        return function (record) {
            return record;
        };
    };
});
var renameRequired = function (dict) {
    return dict.renameRequired;
};
var renameRequiredCons = function (dictIsSymbol) {
    return function (dictIsSymbol1) {
        return function (dictCons) {
            return function (dictCons1) {
                return function (dictCons2) {
                    return function (dictLacks) {
                        return function (dictLacks1) {
                            return function (dictRenameRequired) {
                                return new RenameRequired(function (v) {
                                    return function (record) {
                                        return function (oldRequired) {
                                            var oldRequired$prime = Record_1["delete"](dictIsSymbol)()()(Data_Symbol.SProxy.value)(oldRequired);
                                            var value = Record_1.get(dictIsSymbol)()(Data_Symbol.SProxy.value)(oldRequired);
                                            var newRequired = renameRequired(dictRenameRequired)($$Proxy.value)(record)(oldRequired$prime);
                                            return Record_1.insert(dictIsSymbol1)()()(Data_Symbol.SProxy.value)(value)(newRequired);
                                        };
                                    };
                                });
                            };
                        };
                    };
                };
            };
        };
    };
};
var renameOptionalNil = new RenameOptional(function (v) {
    return function (v1) {
        return function (option) {
            return option;
        };
    };
});
var renameOptional = function (dict) {
    return dict.renameOptional;
};
var rename$prime = function (dict) {
    return dict["rename'"];
};
var recordToRecord = function (dictToRecord) {
    return function (record) {
        return toRecord$prime(dictToRecord)(record);
    };
};
var recordSet = function (dictSet) {
    return function (record$prime) {
        return function (record) {
            return set$prime$prime(dictSet)(record$prime)(record);
        };
    };
};
var recordRename = function (dictRename) {
    return rename$prime(dictRename);
};
var recordFromRecordAndOption = function (record) {
    return {
        optional: record.optional,
        required: record.required
    };
};
var toRecord = function (dictToRecord) {
    return function (option) {
        var record = recordFromRecordAndOption({
            optional: option,
            required: {}
        });
        return toRecord$prime(dictToRecord)(record);
    };
};
var readImplOption = function (dict) {
    return dict.readImplOption;
};
var readForeignRecordRequiredOptional = function (dictReadForeign) {
    return function (dictReadForeign1) {
        return new Simple_JSON.ReadForeign(function (foreign$prime) {
            return Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(Simple_JSON.readImpl(dictReadForeign1)(foreign$prime))(function (required$prime) {
                return Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(Simple_JSON.readImpl(dictReadForeign)(foreign$prime))(function (optional$prime) {
                    return Control_Applicative.pure(Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity))(recordFromRecordAndOption({
                        optional: optional$prime,
                        required: required$prime
                    }));
                });
            });
        });
    };
};
var readForeignOptionOption = function (dictRowToList) {
    return function (dictReadForeignOption) {
        return new Simple_JSON.ReadForeign(readImplOption(dictReadForeignOption)($$Proxy.value));
    };
};
var partitionNilAnyAnyNilNil = Partition;
var partitionConsConsAnyConsAny = function (dictPartition) {
    return Partition;
};
var partitionConsConsAnyAnyAny = function (dictPartition) {
    return Partition;
};
var partitionConsAnyConsAnyCons = function (dictPartition) {
    return Partition;
};
var partitionConsAnyConsAnyAny = function (dictPartition) {
    return Partition;
};
var ordRecordRequiredOptional = function (dictOrd) {
    return function (dictOrd1) {
        return Data_Ord.ordRecord()(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordNil)()(new Data_Symbol.IsSymbol(function () {
            return "required";
        }))(dictOrd1))()(new Data_Symbol.IsSymbol(function () {
            return "optional";
        }))(dictOrd));
    };
};
var optional = function (record$prime) {
    return record$prime.optional;
};
var rename = function (dictRename) {
    return function (record$prime$prime) {
        return function (option) {
            var record$prime = recordFromRecordAndOption({
                optional: option,
                required: {}
            });
            var record = rename$prime(dictRename)(record$prime$prime)(record$prime);
            return optional(record);
        };
    };
};
var renameAny = function (dictPartition) {
    return function (dictRowToList) {
        return function (dictRowToList1) {
            return function (dictRowToList2) {
                return function (dictRenameOptional) {
                    return function (dictRenameRequired) {
                        return new Rename(function (record$prime) {
                            return function (record) {
                                return recordFromRecordAndOption({
                                    optional: renameOptional(dictRenameOptional)($$Proxy.value)(record$prime)(optional(record)),
                                    required: renameRequired(dictRenameRequired)($$Proxy.value)(record$prime)(required(record))
                                });
                            };
                        });
                    };
                };
            };
        };
    };
};
var set$prime = function (dictSet) {
    return function (record$prime$prime) {
        return function (option) {
            var record$prime = recordFromRecordAndOption({
                optional: option,
                required: {}
            });
            var record = set$prime$prime(dictSet)(record$prime$prime)(record$prime);
            return optional(record);
        };
    };
};
var setAny = function (dictPartition) {
    return function (dictRowToList) {
        return function (dictRowToList1) {
            return function (dictRowToList2) {
                return function (dictSetOption) {
                    return function (dictSetRequired) {
                        return new $$Set(function (record$prime) {
                            return function (record) {
                                return recordFromRecordAndOption({
                                    optional: setOption(dictSetOption)($$Proxy.value)(record$prime)(optional(record)),
                                    required: setRequired(dictSetRequired)($$Proxy.value)(record$prime)(required(record))
                                });
                            };
                        });
                    };
                };
            };
        };
    };
};
var showRecord = function (dictShowRecordFields) {
    return function (dictRowToList) {
        return function (dictRowToList1) {
            return function (dictShowOption) {
                return new Data_Show.Show(function (record$prime) {
                    var requiredFields = Data_Show.showRecordFields(dictShowRecordFields)(Type_Data_RowList.RLProxy.value)(required(record$prime));
                    var optionalFields = showOption(dictShowOption)(Type_Data_RowList.RLProxy.value)(optional(record$prime));
                    var go$prime = function ($copy_acc) {
                        return function ($copy_fields$prime) {
                            var $tco_var_acc = $copy_acc;
                            var $tco_done = false;
                            var $tco_result;
                            function $tco_loop(acc, fields$prime) {
                                if (fields$prime instanceof Data_List_Types.Cons) {
                                    $tco_var_acc = acc + (", " + fields$prime.value0);
                                    $copy_fields$prime = fields$prime.value1;
                                    return;
                                };
                                if (fields$prime instanceof Data_List_Types.Nil) {
                                    $tco_done = true;
                                    return acc;
                                };
                                throw new Error("Failed pattern match at Option (line 434, column 23 - line 436, column 27): " + [ fields$prime.constructor.name ]);
                            };
                            while (!$tco_done) {
                                $tco_result = $tco_loop($tco_var_acc, $copy_fields$prime);
                            };
                            return $tco_result;
                        };
                    };
                    var go = (function () {
                        if (requiredFields.length === 0) {
                            if (optionalFields instanceof Data_List_Types.Cons && optionalFields.value1 instanceof Data_List_Types.Nil) {
                                return " " + (optionalFields.value0 + " ");
                            };
                            if (optionalFields instanceof Data_List_Types.Cons) {
                                return " " + (go$prime(optionalFields.value0)(optionalFields.value1) + " ");
                            };
                            if (optionalFields instanceof Data_List_Types.Nil) {
                                return "";
                            };
                            throw new Error("Failed pattern match at Option (line 421, column 13 - line 424, column 28): " + [ optionalFields.constructor.name ]);
                        };
                        if (optionalFields instanceof Data_List_Types.Cons && optionalFields.value1 instanceof Data_List_Types.Nil) {
                            return " " + (Data_String_Common.joinWith(", ")(requiredFields) + (", " + (optionalFields.value0 + " ")));
                        };
                        if (optionalFields instanceof Data_List_Types.Cons) {
                            return " " + (Data_String_Common.joinWith(", ")(requiredFields) + (", " + (go$prime(optionalFields.value0)(optionalFields.value1) + " ")));
                        };
                        if (optionalFields instanceof Data_List_Types.Nil) {
                            return " " + (Data_String_Common.joinWith(", ")(requiredFields) + " ");
                        };
                        throw new Error("Failed pattern match at Option (line 425, column 17 - line 428, column 72): " + [ optionalFields.constructor.name ]);
                    })();
                    return "(Option.recordFromRecord {" + (go + "})");
                });
            };
        };
    };
};
var toRecordAny = function (dictNub) {
    return function (dictUnion) {
        return function (dictRowToList) {
            return function (dictToRecordOption) {
                return new ToRecord(function (record) {
                    var requiredBuilder = Record_Builder.disjointUnion()()(required(record));
                    var optionalBuilder = toRecordOption(dictToRecordOption)($$Proxy.value)(optional(record));
                    return Record_Builder.build(Control_Semigroupoid.compose(Record_Builder.semigroupoidBuilder)(requiredBuilder)(optionalBuilder))({});
                });
            };
        };
    };
};
var writeForeignRecordRequiredOptional = function (dictWriteForeign) {
    return function (dictWriteForeign1) {
        return new Simple_JSON.WriteForeign(function (record) {
            var requiredForeign = Simple_JSON.writeImpl(dictWriteForeign1)(required(record));
            var requiredObject = Foreign.unsafeFromForeign(requiredForeign);
            var optionalForeign = Simple_JSON.writeImpl(dictWriteForeign)(optional(record));
            var optionalObject = Foreign.unsafeFromForeign(optionalForeign);
            return Foreign.unsafeToForeign(Foreign_Object.union(requiredObject)(optionalObject));
        });
    };
};
var modifyOptionNil = new ModifyOption(function (v) {
    return function (v1) {
        return function (option) {
            return option;
        };
    };
});
var modifyOption = function (dict) {
    return dict.modifyOption;
};
var modifyAny = function (dictModifyOption) {
    return function (dictRowToList) {
        return new Modify(function (record) {
            return function (option) {
                return modifyOption(dictModifyOption)($$Proxy.value)(record)(option);
            };
        });
    };
};
var modify$prime$prime = function (dict) {
    return dict["modify''"];
};
var modify$prime = function (dictModify) {
    return function (record) {
        return function (option) {
            return modify$prime$prime(dictModify)(record)(option);
        };
    };
};
var jsonCodecRequiredNil = new JsonCodecRequired(function (v) {
    return function (v1) {
        return Data_Codec.mapCodec(Data_Either.bindEither)(function (v2) {
            return new Data_Either.Right({});
        })(function (v2) {
            return {};
        })(Data_Codec_Argonaut.record);
    };
});
var jsonCodecRequired = function (dict) {
    return dict.jsonCodecRequired;
};
var jsonCodecRequiredCons = function (dictIsSymbol) {
    return function (dictJsonCodecRequired) {
        return function (dictCons) {
            return function (dictCons1) {
                return function (dictLacks) {
                    return new JsonCodecRequired(function (v) {
                        return function (record) {
                            var requiredCodec = jsonCodecRequired(dictJsonCodecRequired)($$Proxy.value)(record);
                            var key = Data_Symbol.reflectSymbol(dictIsSymbol)(Data_Symbol.SProxy.value);
                            var codec = Record_1.get(dictIsSymbol)()(Data_Symbol.SProxy.value)(record);
                            var decode = function (object$prime) {
                                return Control_Bind.bind(Data_Either.bindEither)(Data_Codec.decode(requiredCodec)(object$prime))(function (required$prime) {
                                    var v1 = Foreign_Object.lookup(key)(object$prime);
                                    if (v1 instanceof Data_Maybe.Just) {
                                        var v2 = Data_Codec.decode(codec)(v1.value0);
                                        if (v2 instanceof Data_Either.Left) {
                                            return new Data_Either.Left(new Data_Codec_Argonaut.AtKey(key, v2.value0));
                                        };
                                        if (v2 instanceof Data_Either.Right) {
                                            return new Data_Either.Right(Record_1.insert(dictIsSymbol)()()(Data_Symbol.SProxy.value)(v2.value0)(required$prime));
                                        };
                                        throw new Error("Failed pattern match at Option (line 1598, column 33 - line 1600, column 93): " + [ v2.constructor.name ]);
                                    };
                                    if (v1 instanceof Data_Maybe.Nothing) {
                                        return new Data_Either.Left(new Data_Codec_Argonaut.AtKey(key, Data_Codec_Argonaut.MissingValue.value));
                                    };
                                    throw new Error("Failed pattern match at Option (line 1597, column 7 - line 1601, column 112): " + [ v1.constructor.name ]);
                                });
                            };
                            var encode = function (required$prime) {
                                return Control_Bind.discard(Control_Bind.discardUnit)(Control_Monad_Writer_Trans.bindWriterT(Data_List_Types.semigroupList)(Data_Identity.bindIdentity))(Control_Monad_Writer_Class.tell(Control_Monad_Writer_Trans.monadTellWriterT(Data_List_Types.monoidList)(Data_Identity.monadIdentity))(new Data_List_Types.Cons(new Data_Tuple.Tuple(key, Data_Codec.encode(codec)(Record_1.get(dictIsSymbol)()(Data_Symbol.SProxy.value)(required$prime))), Data_List_Types.Nil.value)))(function () {
                                    return Control_Bind.discard(Control_Bind.discardUnit)(Control_Monad_Writer_Trans.bindWriterT(Data_List_Types.semigroupList)(Data_Identity.bindIdentity))(Control_Monad_Writer_Class.tell(Control_Monad_Writer_Trans.monadTellWriterT(Data_List_Types.monoidList)(Data_Identity.monadIdentity))(Data_Codec.encode(requiredCodec)(Record_1["delete"](dictIsSymbol)()()(Data_Symbol.SProxy.value)(required$prime))))(function () {
                                        return Control_Applicative.pure(Control_Monad_Writer_Trans.applicativeWriterT(Data_List_Types.monoidList)(Data_Identity.applicativeIdentity))(required$prime);
                                    });
                                });
                            };
                            return new Data_Codec.GCodec(decode, encode);
                        };
                    });
                };
            };
        };
    };
};
var jsonCodecOption = function (dict) {
    return dict.jsonCodecOption;
};
var jsonCodecRecordRequiredOptional = function (dictJsonCodecOption) {
    return function (dictJsonCodecRequired) {
        return function (dictRowToList) {
            return function (dictRowToList1) {
                return new JsonCodec(function (name) {
                    return function (record$prime) {
                        var requiredCodec = jsonCodecRequired(dictJsonCodecRequired)(Type_Data_RowList.RLProxy.value)(record$prime);
                        var optionalCodec = jsonCodecOption(dictJsonCodecOption)($$Proxy.value)(record$prime);
                        var encode = function (record) {
                            return Control_Bind.discard(Control_Bind.discardUnit)(Control_Monad_Writer_Trans.bindWriterT(Data_List_Types.semigroupList)(Data_Identity.bindIdentity))(Control_Monad_Writer_Class.tell(Control_Monad_Writer_Trans.monadTellWriterT(Data_List_Types.monoidList)(Data_Identity.monadIdentity))(Data_Codec.encode(requiredCodec)(required(record))))(function () {
                                return Control_Bind.discard(Control_Bind.discardUnit)(Control_Monad_Writer_Trans.bindWriterT(Data_List_Types.semigroupList)(Data_Identity.bindIdentity))(Control_Monad_Writer_Class.tell(Control_Monad_Writer_Trans.monadTellWriterT(Data_List_Types.monoidList)(Data_Identity.monadIdentity))(Data_Codec.encode(optionalCodec)(optional(record))))(function () {
                                    return Control_Applicative.pure(Control_Monad_Writer_Trans.applicativeWriterT(Data_List_Types.monoidList)(Data_Identity.applicativeIdentity))(record);
                                });
                            });
                        };
                        var decode = function (object) {
                            var v = Data_Codec.decode(requiredCodec)(object);
                            if (v instanceof Data_Either.Left) {
                                return new Data_Either.Left(v.value0);
                            };
                            if (v instanceof Data_Either.Right) {
                                var v1 = Data_Codec.decode(optionalCodec)(object);
                                if (v1 instanceof Data_Either.Left) {
                                    return new Data_Either.Left(v1.value0);
                                };
                                if (v1 instanceof Data_Either.Right) {
                                    return new Data_Either.Right(recordFromRecordAndOption({
                                        optional: v1.value0,
                                        required: v.value0
                                    }));
                                };
                                throw new Error("Failed pattern match at Option (line 1433, column 38 - line 1441, column 14): " + [ v1.constructor.name ]);
                            };
                            throw new Error("Failed pattern match at Option (line 1431, column 21 - line 1441, column 14): " + [ v.constructor.name ]);
                        };
                        var codec = new Data_Codec.GCodec(decode, encode);
                        return Data_Codec_Argonaut.object(name)(codec);
                    };
                });
            };
        };
    };
};
var jsonCodec$prime = function (dict) {
    return dict["jsonCodec'"];
};
var jsonCodecRecord = function (dictJsonCodec) {
    return function (name) {
        return function (record$prime) {
            return jsonCodec$prime(dictJsonCodec)(name)(record$prime);
        };
    };
};
var jsonCodec = function (dictJsonCodec) {
    return function (name) {
        return function (record$prime) {
            var codec = jsonCodec$prime(dictJsonCodec)(name)(record$prime);
            var decode = function (json) {
                var v = Data_Codec.decode(codec)(json);
                if (v instanceof Data_Either.Left) {
                    return new Data_Either.Left(v.value0);
                };
                if (v instanceof Data_Either.Right) {
                    return new Data_Either.Right(optional(v.value0));
                };
                throw new Error("Failed pattern match at Option (line 2791, column 17 - line 2793, column 68): " + [ v.constructor.name ]);
            };
            var encode = function (option) {
                return Data_Codec.encode(codec)(recordFromRecordAndOption({
                    optional: option,
                    required: {}
                }));
            };
            return Data_Codec.basicCodec(decode)(encode);
        };
    };
};
var insertOptionNil = new InsertOption(function (v) {
    return function (v1) {
        return function (option) {
            return option;
        };
    };
});
var insertOption = function (dict) {
    return dict.insertOption;
};
var insertAny = function (dictRowToList) {
    return function (dictInsertOption) {
        return new Insert(insertOption(dictInsertOption)($$Proxy.value));
    };
};
var insert$prime$prime = function (dict) {
    return dict["insert''"];
};
var insert$prime = function (dictInsert) {
    return insert$prime$prime(dictInsert);
};
var getOptionNil = new GetOption(function (v) {
    return function (v1) {
        return function (v2) {
            return {};
        };
    };
});
var getOption = function (dict) {
    return dict.getOption;
};
var getAny = function (dictGetOption) {
    return function (dictRowToList) {
        return new Get(function (record) {
            return function (option) {
                return getOption(dictGetOption)($$Proxy.value)(record)(option);
            };
        });
    };
};
var getAllOptionNil = new GetAllOption(function (v) {
    return function (v1) {
        return new Data_Maybe.Just({});
    };
});
var getAllOption = function (dict) {
    return dict.getAllOption;
};
var getAllAny = function (dictRowToList) {
    return function (dictGetAllOption) {
        return new GetAll(getAllOption(dictGetAllOption)($$Proxy.value));
    };
};
var getAll$prime = function (dict) {
    return dict["getAll'"];
};
var getAll = function (dictGetAll) {
    return getAll$prime(dictGetAll);
};
var get$prime$prime = function (dict) {
    return dict["get''"];
};
var get$prime = function (dictGet) {
    return function (record) {
        return function (option) {
            return get$prime$prime(dictGet)(record)(option);
        };
    };
};
var fromRecordRequiredNil = new FromRecordRequired(function (v) {
    return function (v1) {
        return Control_Category.identity(Record_Builder.categoryBuilder);
    };
});
var fromRecordRequired = function (dict) {
    return dict.fromRecordRequired;
};
var fromRecordRequiredCons = function (dictIsSymbol) {
    return function (dictFromRecordRequired) {
        return function (dictCons) {
            return function (dictCons1) {
                return function (dictLacks) {
                    return new FromRecordRequired(function (v) {
                        return function (record) {
                            var rest = fromRecordRequired(dictFromRecordRequired)($$Proxy.value)(record);
                            var value = Record_1.get(dictIsSymbol)()(Data_Symbol.SProxy.value)(record);
                            var first = Record_Builder.insert()()(dictIsSymbol)(Data_Symbol.SProxy.value)(value);
                            return Control_Semigroupoid.compose(Record_Builder.semigroupoidBuilder)(first)(rest);
                        };
                    });
                };
            };
        };
    };
};
var fromRecordOption = function (dict) {
    return dict.fromRecordOption;
};
var fromRecordAny = function (dictFromRecordOption) {
    return function (dictFromRecordRequired) {
        return function (dictUnion) {
            return function (dictRowToList) {
                return function (dictRowToList1) {
                    return new FromRecord(function (record) {
                        return recordFromRecordAndOption({
                            optional: fromRecordOption(dictFromRecordOption)($$Proxy.value)(record),
                            required: Record_Builder.build(fromRecordRequired(dictFromRecordRequired)($$Proxy.value)(record))({})
                        });
                    });
                };
            };
        };
    };
};
var fromRecord$prime = function (dict) {
    return dict["fromRecord'"];
};
var recordFromRecord = function (dictFromRecord) {
    return function (record) {
        return fromRecord$prime(dictFromRecord)(record);
    };
};
var fromRecord = function (dictFromRecord) {
    return function (record$prime) {
        var record = fromRecord$prime(dictFromRecord)(record$prime);
        return optional(record);
    };
};
var eqRecordRequiredOptional = function (dictEq) {
    return function (dictEq1) {
        return Data_Eq.eqRec()(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowNil)()(new Data_Symbol.IsSymbol(function () {
            return "required";
        }))(dictEq1))()(new Data_Symbol.IsSymbol(function () {
            return "optional";
        }))(dictEq));
    };
};
var eqOptionNil = new EqOption(function (v) {
    return function (v1) {
        return function (v2) {
            return true;
        };
    };
});
var ordOptionNil = new OrdOption(function () {
    return eqOptionNil;
}, function (v) {
    return function (v1) {
        return function (v2) {
            return Data_Ordering.EQ.value;
        };
    };
});
var eqOption = function (dict) {
    return dict.eqOption;
};
var eqOptionOption = function (dictEqOption) {
    return function (dictRowToList) {
        return new Data_Eq.Eq(eqOption(dictEqOption)($$Proxy.value));
    };
};
var encodeJsonOptionNil = new EncodeJsonOption(function (v) {
    return function (v1) {
        return Foreign_Object.empty;
    };
});
var encodeJsonOption = function (dict) {
    return dict.encodeJsonOption;
};
var encodeJsonOptionOption = function (dictEncodeJsonOption) {
    return function (dictRowToList) {
        return new Data_Argonaut_Encode_Class.EncodeJson(function (option) {
            return Data_Argonaut_Core.fromObject(encodeJsonOption(dictEncodeJsonOption)($$Proxy.value)(option));
        });
    };
};
var encodeJsonRecordRequiredOptional = function (dictGEncodeJson) {
    return function (dictEncodeJsonOption) {
        return function (dictRowToList) {
            return function (dictRowToList1) {
                return new Data_Argonaut_Encode_Class.EncodeJson(function (record) {
                    var requiredJSON = Data_Argonaut_Encode_Class.gEncodeJson(dictGEncodeJson)(required(record))(Type_Data_RowList.RLProxy.value);
                    var optionalJSON = encodeJsonOption(dictEncodeJsonOption)(Type_Data_RowList.RLProxy.value)(optional(record));
                    return Data_Argonaut_Core.fromObject(Foreign_Object.union(requiredJSON)(optionalJSON));
                });
            };
        };
    };
};
var empty = Foreign_Object.empty;
var fromRecordOptionNil = new FromRecordOption(function (v) {
    return function (v1) {
        return empty;
    };
});
var greeting1 = recordFromRecord(fromRecordAny(fromRecordOptionNil)(fromRecordRequiredCons(new Data_Symbol.IsSymbol(function () {
    return "name";
}))(fromRecordRequiredNil)()()())()()())({
    name: "Pat"
});
var greeting3 = recordSet(setAny()()()()(setOptionNil)(setRequiredCons(new Data_Symbol.IsSymbol(function () {
    return "name";
}))()()()()()(setRequiredNil)))({
    name: "Chris"
})(greeting1);
var user6 = fromRecord(fromRecordAny(fromRecordOptionNil)(fromRecordRequiredNil)()()())({});
var jsonCodecOptionNil = new JsonCodecOption(function (v) {
    return function (v1) {
        return Data_Codec.mapCodec(Data_Either.bindEither)(function (v2) {
            return new Data_Either.Right(empty);
        })(function (v2) {
            return {};
        })(Data_Codec_Argonaut.record);
    };
});
var readForeignOptionNil = new ReadForeignOption(function (v) {
    return function (v1) {
        return Control_Applicative.pure(Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity))(empty);
    };
});
var user = empty;
var user10 = set$prime(setAny()()()()(setOptionNil)(setRequiredNil))({})(user);
var user18 = get$prime(getAny(getOptionNil)())({})(user);
var deleteOptionNil = new DeleteOption(function (v) {
    return function (v1) {
        return function (option) {
            return option;
        };
    };
});
var deleteOption = function (dict) {
    return dict.deleteOption;
};
var deleteAny = function (dictDeleteOption) {
    return function (dictRowToList) {
        return new Delete(deleteOption(dictDeleteOption)($$Proxy.value));
    };
};
var delete$prime$prime = function (dict) {
    return dict["delete''"];
};
var delete$prime = function (dictDelete) {
    return delete$prime$prime(dictDelete);
};
var user16 = delete$prime(deleteAny(deleteOptionNil)())({})(user);
var decodeJsonRecordRequiredOptional = function (dictDecodeJson) {
    return function (dictDecodeJson1) {
        return new Data_Argonaut_Decode_Class.DecodeJson(function (json) {
            var v = Data_Argonaut_Decode_Class.decodeJson(dictDecodeJson1)(json);
            if (v instanceof Data_Either.Left) {
                return new Data_Either.Left(v.value0);
            };
            if (v instanceof Data_Either.Right) {
                var v1 = Data_Argonaut_Decode_Class.decodeJson(dictDecodeJson)(json);
                if (v1 instanceof Data_Either.Left) {
                    return new Data_Either.Left(v1.value0);
                };
                if (v1 instanceof Data_Either.Right) {
                    return new Data_Either.Right(recordFromRecordAndOption({
                        optional: v1.value0,
                        required: v.value0
                    }));
                };
                throw new Error("Failed pattern match at Option (line 322, column 36 - line 330, column 12): " + [ v1.constructor.name ]);
            };
            throw new Error("Failed pattern match at Option (line 320, column 21 - line 330, column 12): " + [ v.constructor.name ]);
        });
    };
};
var decodeJsonOptionNil = new DecodeJsonOption(function (v) {
    return function (v1) {
        return new Data_Either.Right(empty);
    };
});
var decodeJsonOption = function (dict) {
    return dict.decodeJsonOption;
};
var decodeJsonOptionOption = function (dictDecodeJsonOption) {
    return function (dictRowToList) {
        return new Data_Argonaut_Decode_Class.DecodeJson(function (json) {
            var v = Data_Argonaut_Decode_Class.decodeJson(Data_Argonaut_Decode_Class.decodeForeignObject(Data_Argonaut_Decode_Class.decodeJsonJson))(json);
            if (v instanceof Data_Either.Left) {
                return new Data_Either.Left(v.value0);
            };
            if (v instanceof Data_Either.Right) {
                return decodeJsonOption(dictDecodeJsonOption)($$Proxy.value)(v.value0);
            };
            throw new Error("Failed pattern match at Option (line 183, column 21 - line 185, column 78): " + [ v.constructor.name ]);
        });
    };
};
var compareOption = function (dict) {
    return dict.compareOption;
};
var ordOptionOption = function (dictOrdOption) {
    return function (dictRowToList) {
        return new Data_Ord.Ord(eqOptionOption(dictOrdOption.EqOption0()), compareOption(dictOrdOption)($$Proxy.value));
    };
};
var alterOptionNil = new AlterOption(function (v) {
    return function (v1) {
        return function (option) {
            return option;
        };
    };
});
var alterOption = function (dict) {
    return dict.alterOption;
};
var alterAny = function (dictAlterOption) {
    return function (dictRowToList) {
        return new Alter(function (record) {
            return function (option) {
                return alterOption(dictAlterOption)($$Proxy.value)(record)(option);
            };
        });
    };
};
var alter$prime$prime = function (dict) {
    return dict["alter''"];
};
var alter$prime = function (dictIsSymbol) {
    return function (f) {
        return function (v) {
            return function (v1) {
                var key = Data_Symbol.reflectSymbol(dictIsSymbol)(Data_Symbol.SProxy.value);
                var go = function (value$prime) {
                    return f(value$prime);
                };
                var option = Foreign_Object.alter(go)(key)(v1);
                var value = f(Foreign_Object.lookup(key)(v1));
                return {
                    option: option,
                    value: value
                };
            };
        };
    };
};
var $$delete = function (dictIsSymbol) {
    return function (dictCons) {
        return function (dictLacks) {
            return function (proxy) {
                return function (option) {
                    var go = function (v) {
                        return Data_Maybe.Nothing.value;
                    };
                    return (alter$prime(dictIsSymbol)(go)(proxy)(option)).option;
                };
            };
        };
    };
};
var deleteOptionCons = function (dictIsSymbol) {
    return function (dictDeleteOption) {
        return function (dictCons) {
            return function (dictLacks) {
                return new DeleteOption(function (v) {
                    return function (record) {
                        return function (option$prime) {
                            var option = $$delete(dictIsSymbol)()()(Data_Symbol.SProxy.value)(option$prime);
                            return deleteOption(dictDeleteOption)($$Proxy.value)(record)(option);
                        };
                    };
                });
            };
        };
    };
};
var user17 = delete$prime(deleteAny(deleteOptionCons(new Data_Symbol.IsSymbol(function () {
    return "age";
}))(deleteOptionCons(new Data_Symbol.IsSymbol(function () {
    return "username";
}))(deleteOptionNil)()())()())())({
    age: Data_Unit.unit,
    username: Data_Unit.unit
})(user);
var user4 = $$delete(new Data_Symbol.IsSymbol(function () {
    return "age";
}))()()(Data_Symbol.SProxy.value)(user);
var get = function (dictIsSymbol) {
    return function (dictCons) {
        return function (proxy) {
            return function (option) {
                var go = function (value) {
                    return value;
                };
                return (alter$prime(dictIsSymbol)(go)(proxy)(option)).value;
            };
        };
    };
};
var encodeJsonOptionCons = function (dictEncodeJson) {
    return function (dictIsSymbol) {
        return function (dictEncodeJsonOption) {
            return function (dictCons) {
                return new EncodeJsonOption(function (v) {
                    return function (option) {
                        var value$prime = get(dictIsSymbol)()(Data_Symbol.SProxy.value)(option);
                        var key = Data_Symbol.reflectSymbol(dictIsSymbol)(Data_Symbol.SProxy.value);
                        var json = encodeJsonOption(dictEncodeJsonOption)($$Proxy.value)(option);
                        if (value$prime instanceof Data_Maybe.Just) {
                            return Foreign_Object.insert(key)(Data_Argonaut_Encode_Class.encodeJson(dictEncodeJson)(value$prime.value0))(json);
                        };
                        if (value$prime instanceof Data_Maybe.Nothing) {
                            return json;
                        };
                        throw new Error("Failed pattern match at Option (line 732, column 31 - line 738, column 31): " + [ value$prime.constructor.name ]);
                    };
                });
            };
        };
    };
};
var eqOptionCons = function (dictIsSymbol) {
    return function (dictEq) {
        return function (dictEqOption) {
            return function (dictCons) {
                return new EqOption(function (v) {
                    return function (left) {
                        return function (right) {
                            var rest = eqOption(dictEqOption)($$Proxy.value)(left)(right);
                            var leftValue = get(dictIsSymbol)()(Data_Symbol.SProxy.value)(left);
                            var rightValue = get(dictIsSymbol)()(Data_Symbol.SProxy.value)(right);
                            return Data_Eq.eq(Data_Maybe.eqMaybe(dictEq))(leftValue)(rightValue) && rest;
                        };
                    };
                });
            };
        };
    };
};
var getAllOptionCons = function (dictIsSymbol) {
    return function (dictCons) {
        return function (dictCons1) {
            return function (dictLacks) {
                return function (dictGetAllOption) {
                    return new GetAllOption(function (v) {
                        return function (option) {
                            var record$prime = getAllOption(dictGetAllOption)($$Proxy.value)(option);
                            var value$prime = get(dictIsSymbol)()(Data_Symbol.SProxy.value)(option);
                            if (record$prime instanceof Data_Maybe.Just) {
                                if (value$prime instanceof Data_Maybe.Just) {
                                    return new Data_Maybe.Just(Record_1.insert(dictIsSymbol)()()(Data_Symbol.SProxy.value)(value$prime.value0)(record$prime.value0));
                                };
                                if (value$prime instanceof Data_Maybe.Nothing) {
                                    return Data_Maybe.Nothing.value;
                                };
                                throw new Error("Failed pattern match at Option (line 1232, column 31 - line 1234, column 47): " + [ value$prime.constructor.name ]);
                            };
                            if (record$prime instanceof Data_Maybe.Nothing) {
                                return Data_Maybe.Nothing.value;
                            };
                            throw new Error("Failed pattern match at Option (line 1231, column 27 - line 1235, column 45): " + [ record$prime.constructor.name ]);
                        };
                    });
                };
            };
        };
    };
};
var user9 = getAll(getAllAny()(getAllOptionCons(new Data_Symbol.IsSymbol(function () {
    return "age";
}))()()()(getAllOptionCons(new Data_Symbol.IsSymbol(function () {
    return "username";
}))()()()(getAllOptionNil))))(user);
var getOptionConsFunction = function (dictIsSymbol) {
    return function (dictGetOption) {
        return function (dictCons) {
            return function (dictCons1) {
                return function (dictCons2) {
                    return function (dictLacks) {
                        return new GetOption(function (v) {
                            return function (record$prime) {
                                return function (option) {
                                    var record = getOption(dictGetOption)($$Proxy.value)(record$prime)(option);
                                    var optionValue = get(dictIsSymbol)()(Data_Symbol.SProxy.value)(option);
                                    var recordValue = Record_1.get(dictIsSymbol)()(Data_Symbol.SProxy.value)(record$prime);
                                    var value = recordValue(optionValue);
                                    return Record_1.insert(dictIsSymbol)()()(Data_Symbol.SProxy.value)(value)(record);
                                };
                            };
                        });
                    };
                };
            };
        };
    };
};
var getOptionConsMaybe = function (dictIsSymbol) {
    return function (dictGetOption) {
        return function (dictCons) {
            return function (dictCons1) {
                return function (dictCons2) {
                    return function (dictLacks) {
                        return new GetOption(function (v) {
                            return function (record$prime) {
                                return function (option) {
                                    var record = getOption(dictGetOption)($$Proxy.value)(record$prime)(option);
                                    var optionValue = get(dictIsSymbol)()(Data_Symbol.SProxy.value)(option);
                                    var recordValue = Record_1.get(dictIsSymbol)()(Data_Symbol.SProxy.value)(record$prime);
                                    if (optionValue instanceof Data_Maybe.Just) {
                                        return Record_1.insert(dictIsSymbol)()()(Data_Symbol.SProxy.value)(optionValue)(record);
                                    };
                                    if (optionValue instanceof Data_Maybe.Nothing) {
                                        return Record_1.insert(dictIsSymbol)()()(Data_Symbol.SProxy.value)(recordValue)(record);
                                    };
                                    throw new Error("Failed pattern match at Option (line 1114, column 32 - line 1116, column 65): " + [ optionValue.constructor.name ]);
                                };
                            };
                        });
                    };
                };
            };
        };
    };
};
var user20 = get$prime(getAny(getOptionConsFunction(new Data_Symbol.IsSymbol(function () {
    return "age";
}))(getOptionConsMaybe(new Data_Symbol.IsSymbol(function () {
    return "username";
}))(getOptionNil)()()()())()()()())())({
    age: Data_Maybe.maybe("unknown")(Data_Show.show(Data_Show.showInt)),
    username: new Data_Maybe.Just("anonymous")
})(user);
var getOptionConsValue = function (dictIsSymbol) {
    return function (dictGetOption) {
        return function (dictCons) {
            return function (dictCons1) {
                return function (dictCons2) {
                    return function (dictLacks) {
                        return new GetOption(function (v) {
                            return function (record$prime) {
                                return function (option) {
                                    var record = getOption(dictGetOption)($$Proxy.value)(record$prime)(option);
                                    var optionValue = get(dictIsSymbol)()(Data_Symbol.SProxy.value)(option);
                                    var recordValue = Record_1.get(dictIsSymbol)()(Data_Symbol.SProxy.value)(record$prime);
                                    if (optionValue instanceof Data_Maybe.Just) {
                                        return Record_1.insert(dictIsSymbol)()()(Data_Symbol.SProxy.value)(optionValue.value0)(record);
                                    };
                                    if (optionValue instanceof Data_Maybe.Nothing) {
                                        return Record_1.insert(dictIsSymbol)()()(Data_Symbol.SProxy.value)(recordValue)(record);
                                    };
                                    throw new Error("Failed pattern match at Option (line 1141, column 32 - line 1143, column 65): " + [ optionValue.constructor.name ]);
                                };
                            };
                        });
                    };
                };
            };
        };
    };
};
var user19 = get$prime(getAny(getOptionConsValue(new Data_Symbol.IsSymbol(function () {
    return "age";
}))(getOptionConsValue(new Data_Symbol.IsSymbol(function () {
    return "username";
}))(getOptionNil)()()()())()()()())())({
    age: 0,
    username: "anonymous"
})(user);
var getWithDefault = function (dictIsSymbol) {
    return function (dictCons) {
        return function ($$default) {
            return function (proxy) {
                return function (option) {
                    var v = get(dictIsSymbol)()(proxy)(option);
                    if (v instanceof Data_Maybe.Just) {
                        return v.value0;
                    };
                    if (v instanceof Data_Maybe.Nothing) {
                        return $$default;
                    };
                    throw new Error("Failed pattern match at Option (line 2686, column 39 - line 2688, column 32): " + [ v.constructor.name ]);
                };
            };
        };
    };
};
var ordOptionCons = function (dictIsSymbol) {
    return function (dictOrd) {
        return function (dictOrdOption) {
            return function (dictCons) {
                return new OrdOption(eqOptionCons(dictIsSymbol)(dictOrd.Eq0())(dictOrdOption.EqOption0()), function (v) {
                    return function (left) {
                        return function (right) {
                            var rest = compareOption(dictOrdOption)($$Proxy.value)(left)(right);
                            var leftValue = get(dictIsSymbol)()(Data_Symbol.SProxy.value)(left);
                            var rightValue = get(dictIsSymbol)()(Data_Symbol.SProxy.value)(right);
                            var v1 = Data_Ord.compare(Data_Maybe.ordMaybe(dictOrd))(leftValue)(rightValue);
                            if (v1 instanceof Data_Ordering.EQ) {
                                return rest;
                            };
                            if (v1 instanceof Data_Ordering.GT) {
                                return Data_Ordering.GT.value;
                            };
                            if (v1 instanceof Data_Ordering.LT) {
                                return Data_Ordering.LT.value;
                            };
                            throw new Error("Failed pattern match at Option (line 1752, column 32 - line 1755, column 13): " + [ v1.constructor.name ]);
                        };
                    };
                });
            };
        };
    };
};
var showOptionCons = function (dictIsSymbol) {
    return function (dictShow) {
        return function (dictShowOption) {
            return function (dictCons) {
                return new ShowOption(function (v) {
                    return function (option) {
                        var rest = showOption(dictShowOption)($$Proxy.value)(option);
                        var value$prime = get(dictIsSymbol)()(Data_Symbol.SProxy.value)(option);
                        var key = Data_Symbol.reflectSymbol(dictIsSymbol)(Data_Symbol.SProxy.value);
                        if (value$prime instanceof Data_Maybe.Just) {
                            return new Data_List_Types.Cons(key + (": " + Data_Show.show(dictShow)(value$prime.value0)), rest);
                        };
                        if (value$prime instanceof Data_Maybe.Nothing) {
                            return rest;
                        };
                        throw new Error("Failed pattern match at Option (line 2237, column 25 - line 2239, column 31): " + [ value$prime.constructor.name ]);
                    };
                });
            };
        };
    };
};
var toRecordOptionCons = function (dictIsSymbol) {
    return function (dictCons) {
        return function (dictCons1) {
            return function (dictLacks) {
                return function (dictToRecordOption) {
                    return new ToRecordOption(function (v) {
                        return function (option) {
                            var rest = toRecordOption(dictToRecordOption)($$Proxy.value)(option);
                            var value = get(dictIsSymbol)()(Data_Symbol.SProxy.value)(option);
                            var first = Record_Builder.insert()()(dictIsSymbol)(Data_Symbol.SProxy.value)(value);
                            return Control_Semigroupoid.compose(Record_Builder.semigroupoidBuilder)(first)(rest);
                        };
                    });
                };
            };
        };
    };
};
var user8 = toRecord(toRecordAny()()()(toRecordOptionCons(new Data_Symbol.IsSymbol(function () {
    return "age";
}))()()()(toRecordOptionCons(new Data_Symbol.IsSymbol(function () {
    return "username";
}))()()()(toRecordOptionNil))))(user);
var writeForeignOptionCons = function (dictIsSymbol) {
    return function (dictCons) {
        return function (dictWriteForeign) {
            return function (dictWriteForeignOption) {
                return new WriteForeignOption(function (v) {
                    return function (option) {
                        var value$prime = get(dictIsSymbol)()(Data_Symbol.SProxy.value)(option);
                        var key = Data_Symbol.reflectSymbol(dictIsSymbol)(Data_Symbol.SProxy.value);
                        var foreign$prime = writeForeignOption(dictWriteForeignOption)($$Proxy.value)(option);
                        var object = Foreign.unsafeFromForeign(foreign$prime);
                        if (value$prime instanceof Data_Maybe.Just) {
                            return Foreign.unsafeToForeign(Foreign_Object.insert(key)(Simple_JSON.writeImpl(dictWriteForeign)(value$prime.value0))(object));
                        };
                        if (value$prime instanceof Data_Maybe.Nothing) {
                            return foreign$prime;
                        };
                        throw new Error("Failed pattern match at Option (line 2399, column 33 - line 2403, column 35): " + [ value$prime.constructor.name ]);
                    };
                });
            };
        };
    };
};
var insert = function (dictIsSymbol) {
    return function (dictCons) {
        return function (dictLacks) {
            return function (proxy) {
                return function (value) {
                    return function (option) {
                        var go = function (v) {
                            return new Data_Maybe.Just(value);
                        };
                        return (alter$prime(dictIsSymbol)(go)(proxy)(option)).option;
                    };
                };
            };
        };
    };
};
var fromRecordOptionCons = function (dictIsSymbol) {
    return function (dictFromRecordOption) {
        return function (dictCons) {
            return function (dictCons1) {
                return function (dictLacks) {
                    return new FromRecordOption(function (v) {
                        return function (record) {
                            var option = fromRecordOption(dictFromRecordOption)($$Proxy.value)(record);
                            var value = Record_1.get(dictIsSymbol)()(Data_Symbol.SProxy.value)(record);
                            return insert(dictIsSymbol)()()(Data_Symbol.SProxy.value)(value)(option);
                        };
                    });
                };
            };
        };
    };
};
var greeting2 = recordFromRecord(fromRecordAny(fromRecordOptionCons(new Data_Symbol.IsSymbol(function () {
    return "title";
}))(fromRecordOptionNil)()()())(fromRecordRequiredCons(new Data_Symbol.IsSymbol(function () {
    return "name";
}))(fromRecordRequiredNil)()()())()()())({
    name: "Pat",
    title: "Dr."
});
var user7 = fromRecord(fromRecordAny(fromRecordOptionCons(new Data_Symbol.IsSymbol(function () {
    return "age";
}))(fromRecordOptionNil)()()())(fromRecordRequiredNil)()()())({
    age: 10
});
var insertOptionConsValue = function (dictIsSymbol) {
    return function (dictCons) {
        return function (dictCons1) {
            return function (dictLacks) {
                return function (dictInsertOption) {
                    return new InsertOption(function (v) {
                        return function (record) {
                            return function (oldOption) {
                                var option = insertOption(dictInsertOption)($$Proxy.value)(record)(oldOption);
                                var value = Record_1.get(dictIsSymbol)()(Data_Symbol.SProxy.value)(record);
                                return insert(dictIsSymbol)()()(Data_Symbol.SProxy.value)(value)(option);
                            };
                        };
                    });
                };
            };
        };
    };
};
var setOptionCons = function (dictIsSymbol) {
    return function (dictCons) {
        return function (dictCons1) {
            return function (dictCons2) {
                return function (dictLacks) {
                    return function (dictLacks1) {
                        return function (dictSetOption) {
                            return new SetOption(function (v) {
                                return function (record) {
                                    return function (oldOption) {
                                        var oldOption$prime = $$delete(dictIsSymbol)()()(Data_Symbol.SProxy.value)(oldOption);
                                        var option = setOption(dictSetOption)($$Proxy.value)(record)(oldOption$prime);
                                        var value = Record_1.get(dictIsSymbol)()(Data_Symbol.SProxy.value)(record);
                                        return insert(dictIsSymbol)()()(Data_Symbol.SProxy.value)(value)(option);
                                    };
                                };
                            });
                        };
                    };
                };
            };
        };
    };
};
var greeting4 = recordSet(setAny()()()()(setOptionCons(new Data_Symbol.IsSymbol(function () {
    return "title";
}))()()()()()(setOptionNil))(setRequiredNil))({
    title: "Dr."
})(greeting1);
var greeting5 = recordSet(setAny()()()()(setOptionCons(new Data_Symbol.IsSymbol(function () {
    return "title";
}))()()()()()(setOptionNil))(setRequiredCons(new Data_Symbol.IsSymbol(function () {
    return "name";
}))()()()()()(setRequiredNil)))({
    name: "Chris",
    title: "Dr."
})(greeting1);
var user11 = set$prime(setAny()()()()(setOptionCons(new Data_Symbol.IsSymbol(function () {
    return "age";
}))()()()()()(setOptionNil))(setRequiredNil))({
    age: 31
})(user);
var user12 = set$prime(setAny()()()()(setOptionCons(new Data_Symbol.IsSymbol(function () {
    return "age";
}))()()()()()(setOptionCons(new Data_Symbol.IsSymbol(function () {
    return "username";
}))()()()()()(setOptionNil)))(setRequiredNil))({
    age: 31,
    username: "pat"
})(user);
var user13 = set$prime(setAny()()()()(setOptionCons(new Data_Symbol.IsSymbol(function () {
    return "age";
}))()()()()()(setOptionNil))(setRequiredNil))({
    age: true
})(user);
var user2 = insert(new Data_Symbol.IsSymbol(function () {
    return "height";
}))()()(Data_Symbol.SProxy.value)(12)(user);
var insertField = function (dictIsSymbol) {
    return function (dictCons) {
        return function (dictLacks) {
            return function (proxy) {
                return function (option) {
                    var go = function (v) {
                        return Data_Maybe.Nothing.value;
                    };
                    return (alter$prime(dictIsSymbol)(go)(proxy)(option)).option;
                };
            };
        };
    };
};
var alterOptionCons = function (dictAlterOption) {
    return function (dictIsSymbol) {
        return function (dictCons) {
            return function (dictCons1) {
                return function (dictCons2) {
                    return function (dictLacks) {
                        return function (dictLacks1) {
                            return new AlterOption(function (v) {
                                return function (record) {
                                    return function (oldOption) {
                                        var oldOption$prime = $$delete(dictIsSymbol)()()(Data_Symbol.SProxy.value)(oldOption);
                                        var option = alterOption(dictAlterOption)($$Proxy.value)(record)(oldOption$prime);
                                        var optionValue = get(dictIsSymbol)()(Data_Symbol.SProxy.value)(oldOption);
                                        var recordValue = Record_1.get(dictIsSymbol)()(Data_Symbol.SProxy.value)(record);
                                        var v1 = recordValue(optionValue);
                                        if (v1 instanceof Data_Maybe.Just) {
                                            return insert(dictIsSymbol)()()(Data_Symbol.SProxy.value)(v1.value0)(option);
                                        };
                                        if (v1 instanceof Data_Maybe.Nothing) {
                                            return insertField(dictIsSymbol)()()(Data_Symbol.SProxy.value)(option);
                                        };
                                        throw new Error("Failed pattern match at Option (line 554, column 36 - line 556, column 51): " + [ v1.constructor.name ]);
                                    };
                                };
                            });
                        };
                    };
                };
            };
        };
    };
};
var decodeJsonOptionCons = function (dictDecodeJson) {
    return function (dictIsSymbol) {
        return function (dictDecodeJsonOption) {
            return function (dictCons) {
                return function (dictLacks) {
                    return new DecodeJsonOption(function (v) {
                        return function (object$prime) {
                            var option$prime = decodeJsonOption(dictDecodeJsonOption)($$Proxy.value)(object$prime);
                            var key = Data_Symbol.reflectSymbol(dictIsSymbol)(Data_Symbol.SProxy.value);
                            var v1 = Foreign_Object.lookup(key)(object$prime);
                            if (v1 instanceof Data_Maybe.Just) {
                                return Control_Bind.bind(Data_Either.bindEither)(Data_Argonaut_Decode_Class.decodeJson(Data_Argonaut_Decode_Class.decodeJsonMaybe(dictDecodeJson))(v1.value0))(function (value$prime) {
                                    return Control_Bind.bind(Data_Either.bindEither)(option$prime)(function (option) {
                                        if (value$prime instanceof Data_Maybe.Just) {
                                            return new Data_Either.Right(insert(dictIsSymbol)()()(Data_Symbol.SProxy.value)(value$prime.value0)(option));
                                        };
                                        if (value$prime instanceof Data_Maybe.Nothing) {
                                            return new Data_Either.Right(insertField(dictIsSymbol)()()(Data_Symbol.SProxy.value)(option));
                                        };
                                        throw new Error("Failed pattern match at Option (line 613, column 7 - line 615, column 75): " + [ value$prime.constructor.name ]);
                                    });
                                });
                            };
                            if (v1 instanceof Data_Maybe.Nothing) {
                                return Control_Bind.bind(Data_Either.bindEither)(option$prime)(function (option) {
                                    return new Data_Either.Right(insertField(dictIsSymbol)()()(Data_Symbol.SProxy.value)(option));
                                });
                            };
                            throw new Error("Failed pattern match at Option (line 609, column 32 - line 618, column 51): " + [ v1.constructor.name ]);
                        };
                    });
                };
            };
        };
    };
};
var fromRecordOptionConsMaybe = function (dictIsSymbol) {
    return function (dictFromRecordOption) {
        return function (dictCons) {
            return function (dictCons1) {
                return function (dictLacks) {
                    return new FromRecordOption(function (v) {
                        return function (record) {
                            var option = fromRecordOption(dictFromRecordOption)($$Proxy.value)(record);
                            var value$prime = Record_1.get(dictIsSymbol)()(Data_Symbol.SProxy.value)(record);
                            if (value$prime instanceof Data_Maybe.Just) {
                                return insert(dictIsSymbol)()()(Data_Symbol.SProxy.value)(value$prime.value0)(option);
                            };
                            if (value$prime instanceof Data_Maybe.Nothing) {
                                return insertField(dictIsSymbol)()()(Data_Symbol.SProxy.value)(option);
                            };
                            throw new Error("Failed pattern match at Option (line 920, column 31 - line 922, column 51): " + [ value$prime.constructor.name ]);
                        };
                    });
                };
            };
        };
    };
};
var user23 = fromRecord(fromRecordAny(fromRecordOptionConsMaybe(new Data_Symbol.IsSymbol(function () {
    return "age";
}))(fromRecordOptionConsMaybe(new Data_Symbol.IsSymbol(function () {
    return "username";
}))(fromRecordOptionNil)()()())()()())(fromRecordRequiredNil)()()())({
    age: new Data_Maybe.Just(31),
    username: new Data_Maybe.Just("Pat")
});
var user24 = fromRecord(fromRecordAny(fromRecordOptionConsMaybe(new Data_Symbol.IsSymbol(function () {
    return "age";
}))(fromRecordOptionConsMaybe(new Data_Symbol.IsSymbol(function () {
    return "username";
}))(fromRecordOptionNil)()()())()()())(fromRecordRequiredNil)()()())({
    age: new Data_Maybe.Just(31),
    username: Data_Maybe.Nothing.value
});
var user25 = fromRecord(fromRecordAny(fromRecordOptionConsMaybe(new Data_Symbol.IsSymbol(function () {
    return "age";
}))(fromRecordOptionConsMaybe(new Data_Symbol.IsSymbol(function () {
    return "username";
}))(fromRecordOptionNil)()()())()()())(fromRecordRequiredNil)()()())({
    age: Data_Maybe.Nothing.value,
    username: new Data_Maybe.Just("Pat")
});
var user26 = fromRecord(fromRecordAny(fromRecordOptionConsMaybe(new Data_Symbol.IsSymbol(function () {
    return "age";
}))(fromRecordOptionConsMaybe(new Data_Symbol.IsSymbol(function () {
    return "username";
}))(fromRecordOptionNil)()()())()()())(fromRecordRequiredNil)()()())({
    age: Data_Maybe.Nothing.value,
    username: Data_Maybe.Nothing.value
});
var insertOptionConsMaybe = function (dictIsSymbol) {
    return function (dictCons) {
        return function (dictCons1) {
            return function (dictLacks) {
                return function (dictInsertOption) {
                    return new InsertOption(function (v) {
                        return function (record) {
                            return function (oldOption) {
                                var option = insertOption(dictInsertOption)($$Proxy.value)(record)(oldOption);
                                var value$prime = Record_1.get(dictIsSymbol)()(Data_Symbol.SProxy.value)(record);
                                if (value$prime instanceof Data_Maybe.Just) {
                                    return insert(dictIsSymbol)()()(Data_Symbol.SProxy.value)(value$prime.value0)(option);
                                };
                                if (value$prime instanceof Data_Maybe.Nothing) {
                                    return insertField(dictIsSymbol)()()(Data_Symbol.SProxy.value)(option);
                                };
                                throw new Error("Failed pattern match at Option (line 1313, column 37 - line 1315, column 51): " + [ value$prime.constructor.name ]);
                            };
                        };
                    });
                };
            };
        };
    };
};
var jsonCodecOptionCons = function (dictIsSymbol) {
    return function (dictJsonCodecOption) {
        return function (dictCons) {
            return function (dictCons1) {
                return function (dictLacks) {
                    return new JsonCodecOption(function (v) {
                        return function (record) {
                            var option$prime = jsonCodecOption(dictJsonCodecOption)($$Proxy.value)(record);
                            var key = Data_Symbol.reflectSymbol(dictIsSymbol)(Data_Symbol.SProxy.value);
                            var codec = Record_1.get(dictIsSymbol)()(Data_Symbol.SProxy.value)(record);
                            var decode = function (object$prime) {
                                return Control_Bind.bind(Data_Either.bindEither)(Data_Codec.decode(option$prime)(object$prime))(function (option) {
                                    var v1 = Foreign_Object.lookup(key)(object$prime);
                                    if (v1 instanceof Data_Maybe.Just) {
                                        var v2 = Data_Codec.decode(Data_Codec_Argonaut_Compat.maybe(codec))(v1.value0);
                                        if (v2 instanceof Data_Either.Left) {
                                            return new Data_Either.Left(new Data_Codec_Argonaut.AtKey(key, v2.value0));
                                        };
                                        if (v2 instanceof Data_Either.Right) {
                                            if (v2.value0 instanceof Data_Maybe.Just) {
                                                return new Data_Either.Right(insert(dictIsSymbol)()()(Data_Symbol.SProxy.value)(v2.value0.value0)(option));
                                            };
                                            if (v2.value0 instanceof Data_Maybe.Nothing) {
                                                return new Data_Either.Right(insertField(dictIsSymbol)()()(Data_Symbol.SProxy.value)(option));
                                            };
                                            throw new Error("Failed pattern match at Option (line 1516, column 39 - line 1518, column 79): " + [ v2.value0.constructor.name ]);
                                        };
                                        throw new Error("Failed pattern match at Option (line 1514, column 33 - line 1518, column 79): " + [ v2.constructor.name ]);
                                    };
                                    if (v1 instanceof Data_Maybe.Nothing) {
                                        return new Data_Either.Right(insertField(dictIsSymbol)()()(Data_Symbol.SProxy.value)(option));
                                    };
                                    throw new Error("Failed pattern match at Option (line 1513, column 7 - line 1519, column 75): " + [ v1.constructor.name ]);
                                });
                            };
                            var encode = function (option) {
                                return Control_Bind.discard(Control_Bind.discardUnit)(Control_Monad_Writer_Trans.bindWriterT(Data_List_Types.semigroupList)(Data_Identity.bindIdentity))((function () {
                                    var v1 = get(dictIsSymbol)()(Data_Symbol.SProxy.value)(option);
                                    if (v1 instanceof Data_Maybe.Just) {
                                        return Control_Monad_Writer_Class.tell(Control_Monad_Writer_Trans.monadTellWriterT(Data_List_Types.monoidList)(Data_Identity.monadIdentity))(new Data_List_Types.Cons(new Data_Tuple.Tuple(key, Data_Codec.encode(codec)(v1.value0)), Data_List_Types.Nil.value));
                                    };
                                    if (v1 instanceof Data_Maybe.Nothing) {
                                        return Control_Applicative.pure(Control_Monad_Writer_Trans.applicativeWriterT(Data_List_Types.monoidList)(Data_Identity.applicativeIdentity))(Data_Unit.unit);
                                    };
                                    throw new Error("Failed pattern match at Option (line 1525, column 7 - line 1532, column 40): " + [ v1.constructor.name ]);
                                })())(function () {
                                    return Control_Bind.discard(Control_Bind.discardUnit)(Control_Monad_Writer_Trans.bindWriterT(Data_List_Types.semigroupList)(Data_Identity.bindIdentity))(Control_Monad_Writer_Class.tell(Control_Monad_Writer_Trans.monadTellWriterT(Data_List_Types.monoidList)(Data_Identity.monadIdentity))(Data_Codec.encode(option$prime)($$delete(dictIsSymbol)()()(Data_Symbol.SProxy.value)(option))))(function () {
                                        return Control_Applicative.pure(Control_Monad_Writer_Trans.applicativeWriterT(Data_List_Types.monoidList)(Data_Identity.applicativeIdentity))(option);
                                    });
                                });
                            };
                            return new Data_Codec.GCodec(decode, encode);
                        };
                    });
                };
            };
        };
    };
};
var modifyOptionCons = function (dictIsSymbol) {
    return function (dictModifyOption) {
        return function (dictCons) {
            return function (dictCons1) {
                return function (dictCons2) {
                    return function (dictLacks) {
                        return function (dictLacks1) {
                            return new ModifyOption(function (v) {
                                return function (record) {
                                    return function (oldOption) {
                                        var oldOption$prime = $$delete(dictIsSymbol)()()(Data_Symbol.SProxy.value)(oldOption);
                                        var option = modifyOption(dictModifyOption)($$Proxy.value)(record)(oldOption$prime);
                                        var optionValue = get(dictIsSymbol)()(Data_Symbol.SProxy.value)(oldOption);
                                        var recordValue = Record_1.get(dictIsSymbol)()(Data_Symbol.SProxy.value)(record);
                                        if (optionValue instanceof Data_Maybe.Just) {
                                            return insert(dictIsSymbol)()()(Data_Symbol.SProxy.value)(recordValue(optionValue.value0))(option);
                                        };
                                        if (optionValue instanceof Data_Maybe.Nothing) {
                                            return insertField(dictIsSymbol)()()(Data_Symbol.SProxy.value)(option);
                                        };
                                        throw new Error("Failed pattern match at Option (line 1694, column 37 - line 1696, column 51): " + [ optionValue.constructor.name ]);
                                    };
                                };
                            });
                        };
                    };
                };
            };
        };
    };
};
var user21 = modify$prime(modifyAny(modifyOptionCons(new Data_Symbol.IsSymbol(function () {
    return "age";
}))(modifyOptionNil)()()()()())())({
    age: function (v) {
        return true;
    }
})(user);
var readForeignOptionCons = function (dictIsSymbol) {
    return function (dictCons) {
        return function (dictLacks) {
            return function (dictReadForeignOption) {
                return function (dictReadForeign) {
                    return new ReadForeignOption(function (v) {
                        return function (foreign$prime) {
                            var option$prime = readImplOption(dictReadForeignOption)($$Proxy.value)(foreign$prime);
                            var key = Data_Symbol.reflectSymbol(dictIsSymbol)(Data_Symbol.SProxy.value);
                            var hasProperty = function (dictIndex) {
                                return Foreign_Index.hasProperty(dictIndex);
                            };
                            var errorAt = function (dictIndex) {
                                return Foreign_Index.errorAt(dictIndex);
                            };
                            return Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(option$prime)(function (option) {
                                var v1 = hasProperty(Foreign_Index.indexString(Data_Identity.monadIdentity))(key)(foreign$prime);
                                if (v1) {
                                    return Control_Monad_Except_Trans.except(Data_Identity.applicativeIdentity)((function () {
                                        var v2 = Control_Monad_Except.runExcept(Foreign_Index.readProp(Data_Identity.monadIdentity)(key)(foreign$prime));
                                        if (v2 instanceof Data_Either.Left) {
                                            return new Data_Either.Left(Data_Functor.map(Data_List_Types.functorNonEmptyList)(errorAt(Foreign_Index.indexString(Data_Identity.monadIdentity))(key))(v2.value0));
                                        };
                                        if (v2 instanceof Data_Either.Right) {
                                            var v3 = Control_Monad_Except.runExcept(Simple_JSON.readImpl(Simple_JSON.readMaybe(dictReadForeign))(v2.value0));
                                            if (v3 instanceof Data_Either.Left) {
                                                return new Data_Either.Left(Data_Functor.map(Data_List_Types.functorNonEmptyList)(errorAt(Foreign_Index.indexString(Data_Identity.monadIdentity))(key))(v3.value0));
                                            };
                                            if (v3 instanceof Data_Either.Right) {
                                                if (v3.value0 instanceof Data_Maybe.Just) {
                                                    return new Data_Either.Right(insert(dictIsSymbol)()()(Data_Symbol.SProxy.value)(v3.value0.value0)(option));
                                                };
                                                if (v3.value0 instanceof Data_Maybe.Nothing) {
                                                    return new Data_Either.Right(insertField(dictIsSymbol)()()(Data_Symbol.SProxy.value)(option));
                                                };
                                                throw new Error("Failed pattern match at Option (line 1839, column 41 - line 1841, column 81): " + [ v3.value0.constructor.name ]);
                                            };
                                            throw new Error("Failed pattern match at Option (line 1837, column 40 - line 1841, column 81): " + [ v3.constructor.name ]);
                                        };
                                        throw new Error("Failed pattern match at Option (line 1835, column 37 - line 1841, column 81): " + [ v2.constructor.name ]);
                                    })());
                                };
                                if (!v1) {
                                    return Control_Applicative.pure(Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity))(insertField(dictIsSymbol)()()(Data_Symbol.SProxy.value)(option));
                                };
                                throw new Error("Failed pattern match at Option (line 1833, column 5 - line 1842, column 47): " + [ v1.constructor.name ]);
                            });
                        };
                    });
                };
            };
        };
    };
};
var renameOptionalCons = function (dictIsSymbol) {
    return function (dictIsSymbol1) {
        return function (dictCons) {
            return function (dictCons1) {
                return function (dictCons2) {
                    return function (dictLacks) {
                        return function (dictLacks1) {
                            return function (dictRenameOptional) {
                                return new RenameOptional(function (v) {
                                    return function (record) {
                                        return function (oldOptional) {
                                            var oldOptional$prime = $$delete(dictIsSymbol)()()(Data_Symbol.SProxy.value)(oldOptional);
                                            var value$prime = get(dictIsSymbol)()(Data_Symbol.SProxy.value)(oldOptional);
                                            var newOptional = renameOptional(dictRenameOptional)($$Proxy.value)(record)(oldOptional$prime);
                                            if (value$prime instanceof Data_Maybe.Just) {
                                                return insert(dictIsSymbol1)()()(Data_Symbol.SProxy.value)(value$prime.value0)(newOptional);
                                            };
                                            if (value$prime instanceof Data_Maybe.Nothing) {
                                                return insertField(dictIsSymbol1)()()(Data_Symbol.SProxy.value)(newOptional);
                                            };
                                            throw new Error("Failed pattern match at Option (line 1947, column 41 - line 1949, column 59): " + [ value$prime.constructor.name ]);
                                        };
                                    };
                                });
                            };
                        };
                    };
                };
            };
        };
    };
};
var greeting8 = recordRename(renameAny()()()()(renameOptionalCons(new Data_Symbol.IsSymbol(function () {
    return "title";
}))(new Data_Symbol.IsSymbol(function () {
    return "Title";
}))()()()()()(renameOptionalNil))(renameRequiredCons(new Data_Symbol.IsSymbol(function () {
    return "name";
}))(new Data_Symbol.IsSymbol(function () {
    return "Name";
}))()()()()()(renameRequiredNil)))({
    name: Data_Symbol.SProxy.value,
    title: Data_Symbol.SProxy.value
})(greeting1);
var user27 = rename(renameAny()()()()(renameOptionalCons(new Data_Symbol.IsSymbol(function () {
    return "age";
}))(new Data_Symbol.IsSymbol(function () {
    return "age1";
}))()()()()()(renameOptionalNil))(renameRequiredNil))({
    age: Data_Symbol.SProxy.value
})(user);
var user28 = rename(renameAny()()()()(renameOptionalCons(new Data_Symbol.IsSymbol(function () {
    return "username";
}))(new Data_Symbol.IsSymbol(function () {
    return "username2";
}))()()()()()(renameOptionalNil))(renameRequiredNil))({
    username: Data_Symbol.SProxy.value
})(user);
var setOptionConsMaybe = function (dictIsSymbol) {
    return function (dictCons) {
        return function (dictCons1) {
            return function (dictCons2) {
                return function (dictLacks) {
                    return function (dictLacks1) {
                        return function (dictSetOption) {
                            return new SetOption(function (v) {
                                return function (record) {
                                    return function (oldOption) {
                                        var oldOption$prime = $$delete(dictIsSymbol)()()(Data_Symbol.SProxy.value)(oldOption);
                                        var option = setOption(dictSetOption)($$Proxy.value)(record)(oldOption$prime);
                                        var value$prime = Record_1.get(dictIsSymbol)()(Data_Symbol.SProxy.value)(record);
                                        if (value$prime instanceof Data_Maybe.Just) {
                                            return insert(dictIsSymbol)()()(Data_Symbol.SProxy.value)(value$prime.value0)(option);
                                        };
                                        if (value$prime instanceof Data_Maybe.Nothing) {
                                            return insertField(dictIsSymbol)()()(Data_Symbol.SProxy.value)(option);
                                        };
                                        throw new Error("Failed pattern match at Option (line 2104, column 34 - line 2106, column 51): " + [ value$prime.constructor.name ]);
                                    };
                                };
                            });
                        };
                    };
                };
            };
        };
    };
};
var greeting6 = recordSet(setAny()()()()(setOptionConsMaybe(new Data_Symbol.IsSymbol(function () {
    return "title";
}))()()()()()(setOptionNil))(setRequiredCons(new Data_Symbol.IsSymbol(function () {
    return "name";
}))()()()()()(setRequiredNil)))({
    name: "Chris",
    title: new Data_Maybe.Just("Dr.")
})(greeting1);
var greeting7 = recordSet(setAny()()()()(setOptionConsMaybe(new Data_Symbol.IsSymbol(function () {
    return "title";
}))()()()()()(setOptionNil))(setRequiredCons(new Data_Symbol.IsSymbol(function () {
    return "name";
}))()()()()()(setRequiredNil)))({
    name: "Chris",
    title: Data_Maybe.Nothing.value
})(greeting1);
var user14 = set$prime(setAny()()()()(setOptionConsMaybe(new Data_Symbol.IsSymbol(function () {
    return "age";
}))()()()()()(setOptionNil))(setRequiredNil))({
    age: new Data_Maybe.Just(31)
})(user);
var user15 = set$prime(setAny()()()()(setOptionConsMaybe(new Data_Symbol.IsSymbol(function () {
    return "age";
}))()()()()()(setOptionCons(new Data_Symbol.IsSymbol(function () {
    return "username";
}))()()()()()(setOptionNil)))(setRequiredNil))({
    age: new Data_Maybe.Just(31),
    username: "pat"
})(user);
var modify = function (dictIsSymbol) {
    return function (dictCons) {
        return function (dictCons1) {
            return function (proxy) {
                return function (f) {
                    return function (option) {
                        var go = function (value$prime) {
                            if (value$prime instanceof Data_Maybe.Just) {
                                return new Data_Maybe.Just(f(value$prime.value0));
                            };
                            if (value$prime instanceof Data_Maybe.Nothing) {
                                return Data_Maybe.Nothing.value;
                            };
                            throw new Error("Failed pattern match at Option (line 2867, column 15 - line 2869, column 45): " + [ value$prime.constructor.name ]);
                        };
                        return (alter$prime(dictIsSymbol)(go)(proxy)(option)).option;
                    };
                };
            };
        };
    };
};
var user5 = modify(new Data_Symbol.IsSymbol(function () {
    return "age";
}))()()(Data_Symbol.SProxy.value)(function (v) {
    return true;
})(user);
var set = function (dictIsSymbol) {
    return function (dictCons) {
        return function (dictCons1) {
            return function (proxy) {
                return function (value) {
                    return function (option) {
                        var go = function (v) {
                            return new Data_Maybe.Just(value);
                        };
                        return (alter$prime(dictIsSymbol)(go)(proxy)(option)).option;
                    };
                };
            };
        };
    };
};
var user1 = set(new Data_Symbol.IsSymbol(function () {
    return "age";
}))()()(Data_Symbol.SProxy.value)(12)(user);
var user3 = set(new Data_Symbol.IsSymbol(function () {
    return "age";
}))()()(Data_Symbol.SProxy.value)(true)(user);
var alter = function (dictAlter) {
    return function (record) {
        return function (option) {
            return alter$prime$prime(dictAlter)(record)(option);
        };
    };
};
var user22 = alter(alterAny(alterOptionCons(alterOptionNil)(new Data_Symbol.IsSymbol(function () {
    return "age";
}))()()()()())())({
    age: function (v) {
        return new Data_Maybe.Just(true);
    }
})(user);
var age = get(new Data_Symbol.IsSymbol(function () {
    return "age";
}))()(Data_Symbol.SProxy.value)(user);
var staticChecks = [ staticCheck(age), staticCheck(greeting1), staticCheck(greeting2), staticCheck(greeting3), staticCheck(greeting4), staticCheck(greeting5), staticCheck(greeting6), staticCheck(greeting7), staticCheck(greeting8), staticCheck(user1), staticCheck(user2), staticCheck(user3), staticCheck(user4), staticCheck(user5), staticCheck(user6), staticCheck(user7), staticCheck(user8), staticCheck(user9), staticCheck(user10), staticCheck(user11), staticCheck(user12), staticCheck(user13), staticCheck(user14), staticCheck(user15), staticCheck(user16), staticCheck(user17), staticCheck(user18), staticCheck(user19), staticCheck(user20), staticCheck(user21), staticCheck(user22), staticCheck(user23), staticCheck(user24), staticCheck(user25), staticCheck(user26), staticCheck(user27), staticCheck(user28) ];
module.exports = {
    alter: alter,
    fromRecord: fromRecord,
    "delete": $$delete,
    "delete'": delete$prime,
    empty: empty,
    get: get,
    "get'": get$prime,
    getAll: getAll,
    getWithDefault: getWithDefault,
    insert: insert,
    "insert'": insert$prime,
    jsonCodec: jsonCodec,
    jsonCodecRecord: jsonCodecRecord,
    modify: modify,
    "modify'": modify$prime,
    optional: optional,
    recordFromRecord: recordFromRecord,
    recordRename: recordRename,
    recordSet: recordSet,
    recordToRecord: recordToRecord,
    rename: rename,
    required: required,
    set: set,
    "set'": set$prime,
    toRecord: toRecord,
    Alter: Alter,
    "alter''": alter$prime$prime,
    AlterOption: AlterOption,
    alterOption: alterOption,
    DecodeJsonOption: DecodeJsonOption,
    decodeJsonOption: decodeJsonOption,
    Delete: Delete,
    "delete''": delete$prime$prime,
    DeleteOption: DeleteOption,
    deleteOption: deleteOption,
    EncodeJsonOption: EncodeJsonOption,
    encodeJsonOption: encodeJsonOption,
    EqOption: EqOption,
    eqOption: eqOption,
    FromRecord: FromRecord,
    "fromRecord'": fromRecord$prime,
    FromRecordOption: FromRecordOption,
    fromRecordOption: fromRecordOption,
    FromRecordRequired: FromRecordRequired,
    fromRecordRequired: fromRecordRequired,
    Get: Get,
    "get''": get$prime$prime,
    GetOption: GetOption,
    getOption: getOption,
    GetAll: GetAll,
    "getAll'": getAll$prime,
    GetAllOption: GetAllOption,
    getAllOption: getAllOption,
    Insert: Insert,
    "insert''": insert$prime$prime,
    InsertOption: InsertOption,
    insertOption: insertOption,
    JsonCodec: JsonCodec,
    "jsonCodec'": jsonCodec$prime,
    JsonCodecOption: JsonCodecOption,
    jsonCodecOption: jsonCodecOption,
    JsonCodecRequired: JsonCodecRequired,
    jsonCodecRequired: jsonCodecRequired,
    Modify: Modify,
    "modify''": modify$prime$prime,
    ModifyOption: ModifyOption,
    modifyOption: modifyOption,
    OrdOption: OrdOption,
    compareOption: compareOption,
    Partition: Partition,
    ReadForeignOption: ReadForeignOption,
    readImplOption: readImplOption,
    Rename: Rename,
    "rename'": rename$prime,
    RenameOptional: RenameOptional,
    renameOptional: renameOptional,
    RenameRequired: RenameRequired,
    renameRequired: renameRequired,
    "Set": $$Set,
    "set''": set$prime$prime,
    SetOption: SetOption,
    setOption: setOption,
    SetRequired: SetRequired,
    setRequired: setRequired,
    ShowOption: ShowOption,
    showOption: showOption,
    ToRecord: ToRecord,
    "toRecord'": toRecord$prime,
    ToRecordOption: ToRecordOption,
    toRecordOption: toRecordOption,
    WriteForeignOption: WriteForeignOption,
    writeForeignOption: writeForeignOption,
    staticChecks: staticChecks,
    decodeJsonOptionOption: decodeJsonOptionOption,
    encodeJsonOptionOption: encodeJsonOptionOption,
    eqOptionOption: eqOptionOption,
    ordOptionOption: ordOptionOption,
    readForeignOptionOption: readForeignOptionOption,
    showOptionOption: showOptionOption,
    writeForeignOptionOption: writeForeignOptionOption,
    eqRecordRequiredOptional: eqRecordRequiredOptional,
    ordRecordRequiredOptional: ordRecordRequiredOptional,
    decodeJsonRecordRequiredOptional: decodeJsonRecordRequiredOptional,
    encodeJsonRecordRequiredOptional: encodeJsonRecordRequiredOptional,
    readForeignRecordRequiredOptional: readForeignRecordRequiredOptional,
    showRecord: showRecord,
    writeForeignRecordRequiredOptional: writeForeignRecordRequiredOptional,
    alterAny: alterAny,
    alterOptionNil: alterOptionNil,
    alterOptionCons: alterOptionCons,
    decodeJsonOptionNil: decodeJsonOptionNil,
    decodeJsonOptionCons: decodeJsonOptionCons,
    deleteAny: deleteAny,
    deleteOptionNil: deleteOptionNil,
    deleteOptionCons: deleteOptionCons,
    encodeJsonOptionNil: encodeJsonOptionNil,
    encodeJsonOptionCons: encodeJsonOptionCons,
    eqOptionNil: eqOptionNil,
    eqOptionCons: eqOptionCons,
    fromRecordAny: fromRecordAny,
    fromRecordOptionNil: fromRecordOptionNil,
    fromRecordOptionConsMaybe: fromRecordOptionConsMaybe,
    fromRecordOptionCons: fromRecordOptionCons,
    fromRecordRequiredNil: fromRecordRequiredNil,
    fromRecordRequiredCons: fromRecordRequiredCons,
    getAny: getAny,
    getOptionNil: getOptionNil,
    getOptionConsFunction: getOptionConsFunction,
    getOptionConsMaybe: getOptionConsMaybe,
    getOptionConsValue: getOptionConsValue,
    getAllAny: getAllAny,
    getAllOptionNil: getAllOptionNil,
    getAllOptionCons: getAllOptionCons,
    insertAny: insertAny,
    insertOptionNil: insertOptionNil,
    insertOptionConsMaybe: insertOptionConsMaybe,
    insertOptionConsValue: insertOptionConsValue,
    jsonCodecRecordRequiredOptional: jsonCodecRecordRequiredOptional,
    jsonCodecOptionNil: jsonCodecOptionNil,
    jsonCodecOptionCons: jsonCodecOptionCons,
    jsonCodecRequiredNil: jsonCodecRequiredNil,
    jsonCodecRequiredCons: jsonCodecRequiredCons,
    modifyAny: modifyAny,
    modifyOptionNil: modifyOptionNil,
    modifyOptionCons: modifyOptionCons,
    ordOptionNil: ordOptionNil,
    ordOptionCons: ordOptionCons,
    partitionNilAnyAnyNilNil: partitionNilAnyAnyNilNil,
    partitionConsConsAnyConsAny: partitionConsConsAnyConsAny,
    partitionConsAnyConsAnyCons: partitionConsAnyConsAnyCons,
    partitionConsConsAnyAnyAny: partitionConsConsAnyAnyAny,
    partitionConsAnyConsAnyAny: partitionConsAnyConsAnyAny,
    readForeignOptionNil: readForeignOptionNil,
    readForeignOptionCons: readForeignOptionCons,
    renameAny: renameAny,
    renameOptionalNil: renameOptionalNil,
    renameOptionalCons: renameOptionalCons,
    renameRequiredNil: renameRequiredNil,
    renameRequiredCons: renameRequiredCons,
    setAny: setAny,
    setOptionNil: setOptionNil,
    setOptionConsMaybe: setOptionConsMaybe,
    setOptionCons: setOptionCons,
    setRequiredNil: setRequiredNil,
    setRequiredCons: setRequiredCons,
    showOptionNil: showOptionNil,
    showOptionCons: showOptionCons,
    toRecordAny: toRecordAny,
    toRecordOptionNil: toRecordOptionNil,
    toRecordOptionCons: toRecordOptionCons,
    writeForeignOptionNil: writeForeignOptionNil,
    writeForeignOptionCons: writeForeignOptionCons
};

